import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { clearToastMessages } from 'src/actions';
import { ScreenBreakpoint } from 'src/styles';

import { MyAccountLayout } from '../../../lib/Layout/MyAccountLayout/MyAccountLayout';
import { MyAccountSidebarMainMenuItemKey } from '../../../lib/Layout/MyAccountLayout/MyAccountSidebar';
import { AccountNumberSection } from '../PersonalInformation/AccountNumberSection';
import { AccountTypeSection } from '../PersonalInformation/AccountTypeSection';

import { EntityInformationSection } from './EntityInformationSection';

export const EntityInformationPage = () => {
  const dispatch = useDispatch();

  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  useEffect(() => {
    return () => {
      dispatch(clearToastMessages());
    };
  }, []);

  return (
    <MyAccountLayout
      sidebarMenuItemKey={MyAccountSidebarMainMenuItemKey.EntityInformation}
      title={isMobile ? undefined : 'Entity'}
      testId='entity'>
      <AccountTypeSection />
      <AccountNumberSection />
      <EntityInformationSection />
    </MyAccountLayout>
  );
};
